import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CreditCard } from "lucide-react";
import {
  onSubscriptionRequired,
  isOnNoRedirectPage,
  SUBSCRIPTION_REQUIRED_MESSAGE,
} from "../lib/subscriptionLock";

/**
 * Zeigt bei einem global abgefangenen 402 (fehlendes Abo) eine kurze,
 * freundliche Meldung und leitet zur Paketauswahl (/pakete). So fühlt sich die
 * Sperre stets bewusst an — keine rohen Fehler-Toasts oder leeren Zustände.
 */
export default function SubscriptionLockNotice() {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Aktuellen Pfad in einer Ref halten, damit der Listener stabil bleibt.
  const pathnameRef = useRef(location.pathname);
  pathnameRef.current = location.pathname;

  useEffect(() => {
    const unsubscribe = onSubscriptionRequired(() => {
      setVisible(true);
      if (hideTimer.current) clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => setVisible(false), 5000);

      if (!isOnNoRedirectPage(pathnameRef.current)) {
        navigate("/pakete", { replace: true });
      }
    });
    return () => {
      unsubscribe();
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, [navigate]);

  if (!visible) return null;

  return (
    <div className="subscription-lock-notice" role="status" aria-live="polite">
      <div
        className="subscription-lock-notice-card"
        data-testid="notice-subscription-required"
      >
        <span className="subscription-lock-notice-icon">
          <CreditCard size={18} />
        </span>
        <div className="subscription-lock-notice-text">
          <div className="subscription-lock-notice-title">
            {SUBSCRIPTION_REQUIRED_MESSAGE}
          </div>
          <div className="subscription-lock-notice-sub">
            Bitte wähle ein Paket, um diese Funktion zu nutzen.
          </div>
        </div>
      </div>
    </div>
  );
}
